import React from "react";

export const LazyBulkStatusChangePopup = React.lazy(() =>
    import(
        /* webpackChunkName: "CasesOverviewPage" */ "./BulkStatusChangePopup"
    ).then(x => ({ default: x.BulkStatusChangePopup }))
);
